var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "schoolWarp" },
    [
      _c("ZhjySerach", {
        attrs: { queryGroup: _vm.queryGroup, modelData: _vm.modelData },
        on: {
          "update:modelData": function ($event) {
            _vm.modelData = $event
          },
          "update:model-data": function ($event) {
            _vm.modelData = $event
          },
          search: _vm.listBureau,
          matchChange: _vm.TypeChange,
        },
      }),
      _vm._v(" "),
      _c("FunBtn", {
        attrs: {
          funBtns: _vm.funBtns,
          defaultColumn: _vm.defaultColumn,
          isShowSelectChange: true,
        },
        on: { dels: _vm.dels, save: _vm.save, modify: _vm.edit },
      }),
      _vm._v(" "),
      _c("ZhjyTable", {
        attrs: {
          minWidth: _vm.minWidth,
          tableData: _vm.listData,
          columList: _vm.defaultColumn,
          isShowSelection: true,
          options: _vm.options,
          pageNum: _vm.page.pageNumber,
          pageSize: _vm.page.pageSize,
          formatters: _vm.formatters,
          sort: _vm.sort,
        },
        on: {
          "update:pageNum": function ($event) {
            return _vm.$set(_vm.page, "pageNumber", $event)
          },
          "update:page-num": function ($event) {
            return _vm.$set(_vm.page, "pageNumber", $event)
          },
          handleSelectionChange: _vm.handleSelectionChange,
          sortChange: _vm.sortChange,
          viewStage: _vm.viewStage,
          viewWorksList: _vm.viewWorksList,
          registrationList: _vm.registrationList,
          uploadMajor: _vm.uploadMajor,
          "update:sort": function ($event) {
            _vm.sort = $event
          },
        },
      }),
      _vm._v(" "),
      _c("ZhjyPagination", {
        attrs: {
          pageNum: _vm.page.pageNumber,
          pageSize: _vm.page.pageSize,
          total: _vm.totalData,
        },
        on: {
          "update:pageNum": function ($event) {
            return _vm.$set(_vm.page, "pageNumber", $event)
          },
          "update:page-num": function ($event) {
            return _vm.$set(_vm.page, "pageNumber", $event)
          },
          handleCurrentChange: _vm.handleCurrentChange,
          handleSizeChange: _vm.handleSizeChange,
        },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "majorDialog",
          attrs: { title: "上传申报材料", visible: _vm.majorDialog },
          on: {
            "update:visible": function ($event) {
              _vm.majorDialog = $event
            },
          },
        },
        [
          _vm._l(_vm.materialNameList, function (item, i) {
            return _c(
              "div",
              { key: i, staticClass: "upload_div" },
              [
                _c("span", [_vm._v(_vm._s(item.materialName) + "：")]),
                _vm.materialList[i].uploadFileShow
                  ? _c("UploadMaterail", {
                      staticClass: "uploadBtn",
                      attrs: { text: true },
                      on: {
                        successData: function ($event) {
                          return _vm.successData($event, i)
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("p", [
                  _vm.materialList[i].url != null &&
                  _vm.materialList[i].url != ""
                    ? _c(
                        "a",
                        {
                          staticStyle: { cursor: "pointer", color: "blue" },
                          attrs: {
                            href: _vm.materialList[i].url,
                            target: "_blank",
                          },
                        },
                        [_vm._v("查看已上传")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.materialList[i].uploadFileShow
                    ? _c(
                        "a",
                        {
                          staticClass: "el-icon-delete remove",
                          on: {
                            click: function ($event) {
                              return _vm.del(i)
                            },
                          },
                        },
                        [_vm._v("移除")]
                      )
                    : _vm._e(),
                ]),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.majorDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.majorUpdata } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }